module.exports = __webpack_public_path__ + "static/media/24UHCHR10.44c2626c.jpg";